export default "__VITE_ASSET__CHySs4Ol__"